/**
 * @file   : TextCards.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 8:07:14 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import DynamicGrid from '../../../external/components/container/DynamicGrid'
import SimpleContainer from '../../../external/components/container/SimpleContainer'
import Cont from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import {
  getTagTypeFromHTagObj,
  isHTagFromHTagObj,
} from '../../../external/components/text/HTag'
import SimpleDescriptionCard from '../../shared/cards/SimpleDescriptionCard'
import HackMarketingContentWrapper from '../../sharedInternal/container/HackMarketingContentWrapper'
import { getTranslation, isData } from '../InfoUtil'
import SectionAd from './SectionAd'
import SectionDescription from './SectionDescription'
import SectionHeader from './SectionHeader'

const DescriptionCards = ({ intl, section, infoData, mainConfig }) => {
  const getCardFromContent = function (content) {
    const title = getTranslation(
      intl,
      content.title.token,
      content.title.default,
      infoData.infoToken,
    )
    const description = getTranslation(
      intl,
      content.excerpt.token,
      content.excerpt.default,
      infoData.infoToken,
    )
    const linkURL = content.link
    // eslint-disable-next-line prefer-destructuring
    const linkInternal = content.linkInternal
    const linkNewWin = content.newWindow
    const imageURL = infoData.baseImagesFolder + content.image
    const imageLabel = getTranslation(
      intl,
      content.imageDescription.token,
      content.imageDescription.default,
      infoData.infoToken,
    )
    const hTagType = isHTagFromHTagObj(content.htag)
      ? getTagTypeFromHTagObj(content.htag)
      : null

    return (
      <SimpleDescriptionCard
        title={title}
        description={description}
        linkURL={linkURL}
        linkInternal={linkInternal}
        linkNewWin={linkNewWin}
        imageURL={imageURL}
        imageLabel={imageLabel}
        hTagType={hTagType}
      />
    )
  }

  if (isData(section) && section.showSection) {
    return (
      <HackMarketingContentWrapper>
        <SimpleContainer>
          <Cont>
            <SectionHeader intl={intl} section={section} infoData={infoData} />
            <SectionDescription
              intl={intl}
              section={section}
              infoData={infoData}
            />
            <DynamicGrid
              maxItemsPerRow={2}
              colXs={12}
              colSm={12}
              colMd={6}
              colLg={6}
              items={section.content}
              getCellContent={getCardFromContent}
              fluid
            />
          </Cont>
        </SimpleContainer>
        <SectionAd section={section} mainConfig={mainConfig} />
        <Section />
      </HackMarketingContentWrapper>
    )
  }

  return null
}

DescriptionCards.propTypes = {
  intl: PropTypes.object.isRequired,
  theme: PropTypes.string.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default DescriptionCards
